module.exports = __webpack_public_path__ + "media/get-started/product_2-3296f88c.png";